export const getDate = () => {
  const date = new Date().toISOString().slice(0, 10);
  const hour = new Date().toISOString().slice(11, 19);
  const currentDate = `${date} ${hour}`;
  return currentDate;
};
